import { ThunkAction, ThunkDispatch } from '@reduxjs/toolkit';
import { Asset, Tag } from '../../components/assets/types';
import { SelectedTag } from '../../components/assets/details/types';
import { State } from '../../../../types';

export const TAGS_START_LOADING = 'assets/TAGS_START_LOADING';
export const TAGS_LOADED = 'assets/TAGS_LOADED';
export const TAGS_LOADED_FAILED = 'assets/TAGS_LOADED_FAILED';
export const TAG_CREATION_STARTED = 'assets/TAG_CREATION_STARTED';
export const TAG_CREATION_SUCCESSFUL = 'assets/TAG_CREATION_SUCCESSFUL';
export const TAG_CREATION_FAILED = 'assets/TAG_CREATION_FAILED';

export interface TagsStartLoadingAction {
    type: typeof TAGS_START_LOADING;
}

export interface TagsLoadedAction {
    type: typeof TAGS_LOADED;
    payload: Tag[];
}

export interface TagsLoadedFailedAction {
    type: typeof TAGS_LOADED_FAILED;
}

export interface TagCreationStarted {
    type: typeof TAG_CREATION_STARTED;
}

export interface TagCreationSuccessful {
    type: typeof TAG_CREATION_SUCCESSFUL;
    payload: { tag: SelectedTag; asset?: Asset };
}

export interface TagCreationFailed {
    type: typeof TAG_CREATION_FAILED;
    payload: { tag: SelectedTag };
}

export type TagsActions =
    | TagCreationStarted
    | TagCreationSuccessful
    | TagCreationFailed
    | TagsStartLoadingAction
    | TagsLoadedAction
    | TagsLoadedFailedAction;

export type TagsThunkAction<R> = ThunkAction<R, State, undefined, TagsActions>;

export type TagsThunkDispatch = ThunkDispatch<State, undefined, TagsActions>;
